export const PRIMARY_GOALS = [
  { id: 'increaseSales' },
  { id: 'reduceCosts' },
  { id: 'improveOperations' },
  { id: 'other' },
]

export const BUSINESS_TYPES = [
  { id: 'retail' },
  { id: 'restaurant' },
  { id: 'online' },
  { id: 'manufacture' },
  { id: 'suppliers' },
  { id: 'services' },
  { id: 'construction' },
  { id: 'other' },
]

export const CLIENT_TYPES = [
  { id: 'b2c' },
  { id: 'b2b' },
  { id: 'b2b>b2c' },
  { id: 'b2c>b2b' },
  { id: 'b2c&b2b' },
]

export const EMPLOYEE_COUNTS = [
  { id: '0' },
  { id: '1-5' },
  { id: '5-20' },
  { id: '20-50' },
  { id: '50+' },
]

export const MODULES = [
  { id: 'sales' },
  { id: 'complexSales' },
  { id: 'spendings' },
  { id: 'shift' },
  { id: 'stock' },
  { id: 'supplies' },
  { id: 'writeOffs' },
  { id: 'revisions' },
  { id: 'transfers' },
  { id: 'salary' },
  { id: 'checklist' },
  { id: 'ecommerce' },
  { id: 'updates' },
  { id: 'payments' },
  { id: 'printStickers' },
  { id: 'manufactures' },
  { id: 'clients' },
]

export const ADDITIONAL_FEATURES = [
  {id: 'ofd'}, 
  {id: 'accounting'},
  {id: 'invoicing'},
  {id: 'documents'},
  {id: 'todo'},
  {id: 'none'},
]

export const PRIOR_EXPERIENCE = [
  {id: 'no'}, 
  {id: 'paper'}, 
  {id: 'excel'},  
  {id: 'specific'}, 
  {id: '1c'}, 
]

export const SETUP_OPTIONS = [
  {id: 'no'}, 
  {id: 'partial'}, 
  {id: 'full'}, 
]

export const TRAFFIC_SOURCE = [
  {id: 'social'}, 
  {id: 'appstore'}, 
  {id: 'webSearch'},
  {id: 'recommendation'}, 
  {id: 'youtube'},
  {id: 'other'}, 
]

export const DEFAULT_UNITS = [{
  id: 'piece',
}, {
  id: 'kg',
}, {
  id: 'gr',
}, {
  id: 'l',
}, {
  id: 'ml',
}]